import Vue from 'vue'
import App from './AppScoresNFL.vue'

Vue.config.productionTip = false

new Vue({
  render: h => h(App),
}).$mount('#app')
